import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

import { SharingData } from '@app/widgets/canvas/types';

type SharingState = {
  share: SharingData;
  isOpen: boolean;
  shareUrl: string | null;
  entityType: 'workspace' | 'project';
};

type SharingAction = {
  setSharingState: (newData: SharingState['share']) => void;
  changeSharingData: (dataToChange: Partial<SharingState['share']>) => void;
  getToken: () => string | undefined;
  setIsOpen: (isOpen: boolean) => void;
  setShareUrl: (url: string | null) => void;
  setEntityType: (entityType: 'workspace' | 'project') => void;
};

const initialState: SharingState = {
  share: null,
  isOpen: false,
  shareUrl: null,
  entityType: 'workspace',
};

export const useSharingDialogData = create<SharingState & SharingAction>()(
  immer((set, getState) => ({
    ...initialState,
    setSharingState: (newData) =>
      set((state) => {
        state.share = newData;
      }),

    getToken: () => {
      const match = getState().share?.url.match(/\/s\/([^/?#]+)/);
      return match ? match[1] : undefined;
    },

    changeSharingData: (dataToChange) =>
      set((state) => {
        if (state.share === null) {
          state.share = {
            url: '',
            is_private: false,
            is_owner: true,
            need_pin: false,
          };
        }

        if (dataToChange?.need_pin !== undefined) {
          state.share.need_pin = dataToChange.need_pin;
        }
        if (dataToChange?.url !== undefined) {
          state.share.url = dataToChange.url;
        }
        if (dataToChange?.is_private !== undefined) {
          state.share.is_private = dataToChange.is_private;
        }
        if (dataToChange?.is_owner !== undefined) {
          state.share.is_owner = dataToChange.is_owner;
        }
        if (dataToChange?.is_owner !== undefined) {
          state.share.is_owner = dataToChange.is_owner;
        }
      }),
    setIsOpen: (isOpen) =>
      set((state) => {
        state.isOpen = isOpen;
      }),
    setShareUrl: (url) =>
      set((state) => {
        state.shareUrl = url;
      }),
    setEntityType: (entityType) =>
      set((state) => {
        state.entityType = entityType;
      }),
  })),
);
